import React, { useState } from "react";
import { ArrowLeft, CheckCircle2, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { requestPasswordReset } from "../api/auth";
import CehrBrandmark from "../assets/cehr-brandmark.png";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    setMessage("");
    try {
      setLoading(true);
      const response = await requestPasswordReset(email.trim());
      setMessage(response?.message || "If an account matches that email, a reset link has been sent.");
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex min-h-[100dvh] items-center justify-center bg-gradient-to-br from-[#f8f5ff] via-white to-[#eef2ff] px-4 py-8 font-Outfit">
      <section className="w-full max-w-md rounded-3xl border border-blue-100 bg-white p-6 shadow-xl shadow-blue-100/60 sm:p-8">
        <div className="mb-6 flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-2xl bg-white shadow-sm">
            <img src={CehrBrandmark} alt="Cephas HR" className="h-8 w-8 object-contain" />
          </div>
          <div><p className="font-bold text-gray-900">CeHR</p><p className="text-xs text-gray-500">Secure account recovery</p></div>
        </div>
        <h1 className="text-2xl font-bold text-gray-900">Forgot your password?</h1>
        <p className="mt-2 text-sm leading-6 text-gray-500">Enter the email used for your admin or staff account. We’ll send a secure link that expires in 30 minutes.</p>
        {message ? (
          <div className="mt-6 rounded-2xl border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800">
            <CheckCircle2 className="mb-2 h-5 w-5" />
            {message}
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6">
            <label className="block text-sm font-medium text-gray-700">Email address
              <span className="relative mt-2 block">
                <Mail className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400" />
                <input required type="email" value={email} onChange={(event) => setEmail(event.target.value)} placeholder="you@company.com" className="w-full rounded-xl border border-gray-200 py-3 pl-11 pr-4 outline-none transition focus:border-[#1233CC] focus:ring-4 focus:ring-blue-100" />
              </span>
            </label>
            {error ? <p className="mt-3 text-sm text-red-600">{error}</p> : null}
            <button disabled={loading} className="mt-5 w-full rounded-xl bg-gradient-to-r from-[#1233CC] to-[#00BAFF] py-3 font-semibold text-white shadow-lg shadow-blue-200 disabled:opacity-60">{loading ? "Sending link..." : "Send reset link"}</button>
          </form>
        )}
        <Link to="/login" className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#1233CC]"><ArrowLeft className="h-4 w-4" />Back to sign in</Link>
      </section>
    </main>
  );
}
